import { initTheme } from "@/utils/theme";

import { IChannelConfigs, IChannelTheme } from "../types";
import hoteluxConfig from "./config";
const theme: IChannelTheme = {};
export default {
  configs: {
    ...hoteluxConfig.configs,
    key: "hoteluxjp",
    defaultLanguage: "jp",
    telephoneCountryCode: "81",
    UserListnameReverse: true,
    currency: "JPY",
    nameFormatReverse: true,
    airlineMatchJalRuleId: "6786175aeec68609a7c6ce8e",
    airlineMatchSgRuleId: "6455ef3af26b526d1e3c239a",
    authGoogleWebClientId:
      "575776218865-3jelkj911fhrqtv2743j1svkkrrkh8h9.apps.googleusercontent.com",
    components: {
      ...hoteluxConfig.configs.components
    },
    pages: {
      ...hoteluxConfig.configs.pages,
      Index: {
        logoUrl: "https://qiniu-cdn.hotelux.com/logo-center-hotelux.png",
        banners: {
          ...hoteluxConfig.configs.pages?.Index?.banners
        },
        featuredHotels: [
          "6756505e12134c242d6dc620", // 大阪华尔道夫
          "679350606279ad0aad3e6890", // 大阪Patina
          "5b35e54d74b5e5b4a112b33c", // 东京丽思
          "5b506c826a8860a3024da116", // 曼谷文华东方
          "5c02b3827f37473ac3cae746", // 新加坡莱佛士
          "5c0e8df1f2cb097966521d28", // 香港瑰丽
          "5b5073eb6a8860a3024de474" // 香港半岛
        ],
        JourneyList: [
          "5dab53d18dce6d537158d5a9",
          "5b35e88d21b146b104fd2da2",
          "66cedbcf281f2a375635c245",
          "5b5055c574de201bce684da6"
        ]
      }
    }
  },
  init() {
    initTheme(theme);
  }
} as IChannelConfigs;
